export enum actionTypes {
    LIVE_GAMES_RESET = 'LIVE_GAMES:RESET',
    LIVE_GAMES_SOCKET_SET = 'LIVE_GAMES:SOCKET:SET',
    LIVE_GAMES_TABLES_ADD = 'LIVE_GAMES:TABLES:ADD',
    LIVE_GAMES_TABLES_REMOVE = 'LIVE_GAMES:TABLES:REMOVE',
    LIVE_GAMES_TABLES_UPDATE = 'LIVE_GAMES:TABLES:UPDATE',
    LIVE_GAMES_SUBSCRIPTION_ADD = 'LIVE_GAMES:SUBSCRIPTION:ADD',
    LIVE_GAMES_SUBSCRIPTION_REMOVE = 'LIVE_GAMES:SUBSCRIPTION:REMOVE',
    LIVE_GAMES_IS_NEED_TO_START_UPDATE = 'LIVE_GAMES:IS_NEED_TO_START:UPDATE',
    LIVE_GAMES_CONNECTION_STATUS_UPDATE = 'LIVE_GAMES:CONNECTION_STATUS:UPDATE',
    LIVE_GAMES_RECONNECTION_STATUS_UPDATE = 'LIVE_GAMES:RECONNECTION_STATUS:UPDATE',
    LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE = 'LIVE_GAMES:IMAGES_TIMESTAMP:UPDATE',
    LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE = 'LIVE_GAMES:IMAGES_INTERVAL_ID:UPDATE'
}
